import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import {
    Action,
    createFeatureSelector,
    createReducer,
    createSelector,
    on
} from '@ngrx/store';
import { IOversignTime } from '../IOversignTime';
import * as OversignTimeActions from './oversign-time.actions';

export const oversignTimeFeatureKey = 'oversignTime';

export interface State extends EntityState<IOversignTime> {}

export const adapter: EntityAdapter<IOversignTime> =
    createEntityAdapter<IOversignTime>({
        selectId: (model: IOversignTime) => model.EmpTimeID
    });

export const initialState: State = adapter.getInitialState({});

const oversignTimeReducer = createReducer(
    initialState,
    on(OversignTimeActions.addOversignTime, (state, action) =>
        adapter.addOne(action.oversignTime, state)
    ),
    on(OversignTimeActions.upsertOversignTime, (state, action) =>
        adapter.upsertOne(action.oversignTime, state)
    ),
    on(OversignTimeActions.addOversignTimes, (state, action) =>
        adapter.addMany(action.oversignTimes, state)
    ),
    on(OversignTimeActions.upsertOversignTimes, (state, action) =>
        adapter.upsertMany(action.oversignTimes, state)
    ),
    on(OversignTimeActions.updateOversignTime, (state, action) =>
        adapter.updateOne(action.oversignTime, state)
    ),
    on(OversignTimeActions.updateOversignTimes, (state, action) =>
        adapter.updateMany(action.oversignTimes, state)
    ),
    on(OversignTimeActions.deleteOversignTime, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(OversignTimeActions.deleteOversignTimes, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(OversignTimeActions.loadOversignTimes, (state, action) =>
        adapter.setAll(action.oversignTimes, state)
    ),
    on(OversignTimeActions.clearOversignTimes, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return oversignTimeReducer(state, action);
}

const localState = createFeatureSelector<State>(oversignTimeFeatureKey);
export const getEntities = createSelector(localState, x => x.entities);
export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(localState);
